import { useState, useEffect, useRef } from "react";
import { ErrorCard, LoadingCard, MainContainer } from "../../components";
import { Button, Input, Card, CardBody } from "@heroui/react";
import { usePost, useFetchWithBody } from "../../api/reactQueryCustomHooks";
import { apiRoute, funValidateNoInput, linksUrl } from "../../constants/enum";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { resetDetail, setDetailParams } from "../../state/sizeSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@fortawesome/free-solid-svg-icons";
import { useModalToast } from "../../components/modalToast/ModalToastContext";


const PolishSizeMasterEntry = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const { detailParams, isNewEntry } = useSelector((state) => state.polishSize);
    const [submitBtnId, setSubmitBtnId] = useState("")
    const submitLockRef = useRef(false);//
    const{show}=useModalToast()

    const [formData, setFormData] = useState({
        szCode: "",
        fSize: "",
        tSize: "",
        szOrd: "",
        szOf: ""
    });

    const { data: details = [], isPending: isLoading, mutate: filterDetail } = usePost({
        url: apiRoute.polishSize.fetchEntryDetail,
        queryKey: "fetchSizeById",
    });


    // Fetch data when `detailParams?.Sz_Code` exists
    useEffect(() => {
        if (detailParams && Object.keys(detailParams).length > 0) {

            filterDetail({
                data: {
                    Sz_Code: detailParams.Sz_Code
                }
            })
        }
    }, [detailParams]);

    useEffect(() => {
        if (!isNewEntry && details && Object.keys(details).length > 0) {
            setFormData({
                szCode: details.Sz_Code || "",
                fSize: details.F_Size || "",
                tSize: details.T_Size || "",
                szOrd: details.Sz_Ord || "",
            });

        }
    }, [details]);



    const handleChange = (e) => {
        const { name, value } = e.target
        let isValid = 1
        if (["fSize", "tsize", "szOrd"].includes(name)) {
            if (funValidateNoInput(value))
                setFormData({ ...formData, [name]: value });
        }
        else
            setFormData({ ...formData, [name]: value });
    };

    const { mutate: funAddUpdate, isPending, isError } = usePost({
        queryKey: "size",
        url: apiRoute.polishSize.AddUpdate,
        onSuccessTasks: () => {
            dispatch(resetDetail());
            submitLockRef.current = false;
            if (submitBtnId == 'btnSaveNew') {
                setFormData({
                    szCode: "",
                    tSize: "",
                    fSize: "",
                    szOrd: "",
                })

            }
            else
                navigate(linksUrl.diamondParamater.polishSize.polishSizeMaster);

        },
    });
    const funSubmit = () => {
        funAddUpdate({
            data: {
                sz_code: formData.szCode,
                f_size: formData.fSize,
                t_size: formData.tSize,
                sz_ord: formData.szOrd,
                sz_of: 'P',
                rec_status: !isNewEntry ? 1 : 2
            }
        });

    }
    const onSuccessChkDupCode = (data) => {
        if (!submitLockRef.current) return; // 🚫 ignore stale calls
        let isDuplicate = 0
        if (isNewEntry && data && data.length > 0) {

            if (data[0].count > 0) {
                
                    show(`Duplicate Size Code Not Allow It Must Be Unique `)
                    setFormData({ ...formData, szCode: "" })
                
                isDuplicate = 1
                submitLockRef.current = false;
            }
        }
        if (isDuplicate == 0) {
            funSubmit()
        }
    }
    const { mutate: funCheckDuplicateSzCode } = usePost({
        queryKey: "CheckSzCode",
        url: apiRoute.polishSize.CheckSzCode,
        onSuccessTasks: onSuccessChkDupCode
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitBtnId(e.nativeEvent.submitter.id)
        if (submitLockRef.current) return;
        submitLockRef.current = true;
        if (isNewEntry) {
            funCheckDuplicateSzCode({
                data: {
                    SZ_CODE: formData.szCode
                }
            })
        }
        if (!isNewEntry) {
            funSubmit()
        }

    };

    const { data: ordData = [] } = useFetchWithBody({
        url: apiRoute.polishSize.getNextSzOrd,
        queryKey: "getNextSzOrd",
    });


    useEffect(() => {
        if (isNewEntry) {
            setFormData((prev) => ({
                ...prev,
                szOrd: ordData.nextSzOrd,
            }));
        }
    }, [isNewEntry, ordData]);
    if (isLoading || isPending) return <LoadingCard />;
    if (isError) return <ErrorCard />;


    return (
        <MainContainer
            pageName="Polish Size Entry"
            breadcrumbs={["Diamond Parameter", "Polish Size Master"]}
            prevPage={{ show: true, onClick: () => navigate(linksUrl.diamondParamater.polishSize.polishSizeMaster) }}
        >
            <Card className="p-6">
                <CardBody>

                    <form onSubmit={handleSubmit}>
                        <div className="grid gap-4">
                            <Input label="Size Code" size="sm" maxLength={10}
                                readOnly={isNewEntry ? false : true} name="szCode" value={formData.szCode} onChange={handleChange} isRequired />
                            <h2 className="text-red-300 " style={{ fontSize: "0.7rem" }}>Size code cannot be longer than 10 characters</h2>
                            <Input label="From Size" size="sm" name="fSize" value={formData.fSize} onChange={handleChange} isRequired />
                            <Input label="To Size" size="sm" name="tSize" value={formData.tSize} onChange={handleChange} />
                            <Input label="Size Order" size="sm" name="szOrd" type="number" value={formData.szOrd} onChange={handleChange} />
                            <div className="flex  gap-4 justify-center" >
                                <Button type="submit" size="sm" id="btnSave" color="primary" isLoading={isPending}>
                                    {isNewEntry ? "Save" : "Update"}
                                </Button>
                                <Button
                                    id="btnSaveNew"
                                    color="success"
                                    type="submit"
                                    size="sm"
                                    variant="shadow"
                                    className="text-white"
                                    startContent={<FontAwesomeIcon className=" text-md text-white" icon={faFile} />}
                                >
                                    Save & New
                                </Button>
                            </div>

                        </div>
                    </form>

                </CardBody>
            </Card>
        </MainContainer>
    );
};

export default PolishSizeMasterEntry;

